import camelCase from "lodash-es/camelCase";
import React from "react";
import { useRenderOn } from "src/hooks";
import styled from "styled-components";

import phone from "../../../../../../../../../assets/images/phone.svg";
import tooltips from "../../../../../../../../../assets/images/tooltips.svg";
import { footerInteractionTracking } from "../../../../../../../../../services/analytics.service";
import { translate } from "../../../../../../../../../services/translation.service";
import theme from "../../../../../../../../../theme";
import { P } from "../../../../../../../../Semantic";
import ContactInfoItems from "../ContactInfoItem";

const ContactItemWrapper = styled.address`
  display: flex;
  justify-content: center;
  font-style: normal;
`;

const TermsAndConditions = styled.section``;

const Text = styled(P)`
  color: rgb(155, 155, 155);
  font-size: ${theme.fontSizes.small};
`;

const contactInfoMobile = (): JSX.Element => (
  <>
    <ContactItemWrapper>
      <ContactInfoItems
        info={translate("footer.phoneNumber")}
        iconName={phone}
        to="tel:09-70-83-03-60"
        onClick={(): void =>
          footerInteractionTracking(camelCase(translate("footer.phoneNumber")))
        }
      />
      <ContactInfoItems
        info={translate("footer.contactUs")}
        iconName={tooltips}
        to={translate("links.hcRequestsNew")}
        onClick={(): void =>
          footerInteractionTracking(camelCase(translate("footer.contactUs")))
        }
      />
    </ContactItemWrapper>
    <TermsAndConditions>
      <Text>{translate("footer.localCallPrice")}</Text>
      <Text>{translate("footer.workingHours")}</Text>
    </TermsAndConditions>
  </>
);

const contactInfoTablet = (): JSX.Element => (
  <>
    <ContactInfoItems
      info={translate("footer.phoneNumber")}
      to="tel:09-70-83-03-60"
      onClick={(): void =>
        footerInteractionTracking(camelCase(translate("footer.phoneNumber")))
      }
    />
    <TermsAndConditions>
      <Text>({translate("footer.localCallPrice")})</Text>
      <br />
      <Text>{translate("footer.workingHours")}</Text>
    </TermsAndConditions>
    <ContactInfoItems
      info={translate("footer.contactUs")}
      to={translate("links.hcRequestsNew")}
      onClick={(): void =>
        footerInteractionTracking(camelCase(translate("footer.contactUs")))
      }
    />
  </>
);

const ContactInfo = (): JSX.Element => {
  const { mdOrDown } = useRenderOn();

  const RenderedComponent = mdOrDown
    ? (): JSX.Element => contactInfoMobile()
    : (): JSX.Element => contactInfoTablet();

  return <RenderedComponent />;
};

export default ContactInfo;
